import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {RecordingModel} from './recording.model';
import moment from 'moment';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-audio',
    template: `
    <div class="controls">
      <button class="btn btn-default btn-xs" [ngClass]="{'is-loading': isLoading}"
              [title]="playPauseTitle()" (click)="playPause()">
        <i class="material-icons" *ngIf="!isPlaying && !isLoading">play_arrow</i>
        <i class="material-icons" *ngIf="isPlaying">pause</i>
        <span class="k-i-loading k-icon"></span>
      </button>
      <button class="btn btn-default btn-xs" title="Replay" *ngIf="isPlaying || isLoaded" (click)="reloadAudio()">
        <i class="material-icons">replay</i>
      </button>
      <a class="btn btn-default btn-xs" title="Download" *ngIf="showDownload" href="{{downloadSrc}}">
        <i class="material-icons">download</i>
      </a>
      <button class="btn btn-default btn-xs" title="Delete" *ngIf="showDelete" (click)="onDelete()">
        <i class="material-icons">delete</i>
      </button>
    </div>
  `,
    styles: [
        '.controls {display: block; margin-bottom: 3px; }',
        '.card-title {font-size: 15px; display: flex;}',
        '.expand-title {flex: auto; cursor: pointer;}',
        '.card-title.collapsed {margin-bottom: -10px; }'
    ],
    standalone: true,
    imports: [NgClass, NgIf]
})
export class AudioComponent implements OnChanges, OnInit, OnDestroy {

  @Input() type: 'recording' | 'voicemail' | 'audio';
  @Input() src: string;
  @Input() model: RecordingModel;
  @Input() showDownload: boolean;
  @Input() showDelete: boolean;
  @Output() delete = new EventEmitter<any>();
  @Output() error = new EventEmitter<any>();
  @Output() onPlay = new EventEmitter<AudioComponent>();

  public downloadSrc: string;
  public isPlaying = false;
  public isLoading = false;
  public isLoaded = false;

  public audio?: HTMLAudioElement;

  constructor() {

  }

  async playPause() {
    console.log('playPause: ' + this.src);
    if (!this.audio) {
      this.ngOnChanges();
    }

    this.onPlay.emit(this);
    if (!this.isPlaying) {
      if (!this.audio?.src) {
        this.isLoading = true;
        this.audio!.src = this.src;
        this.audio!.load();
      }
      try {
        await this.audio!.play();
        this.isLoading = false;
        this.isLoaded = true;
        this.isPlaying = true;
      } catch (e: any) {
        this.isPlaying = false;
        this.isLoading = false;
        console.log(e);
        if (e.code !== 20) {
          this.error.emit(e);
          this.ngOnChanges();
        }
      }
    } else {
      this.pause();
    }
  }

  playPauseTitle(): string {
    let title = this.isPlaying ? 'Pause' : 'Play';

    if (this.model.extension) {
      title += ' - agent: ' + this.model.extension;
    }
    if (this.model.extensionName) {
      title += ` (${this.model.extensionName})`;
    }

    return title;
  }

  stop() {
    if (this.audio) {
      console.log('stop player');
      this.audio.pause();
      this.isPlaying = false;
      this.isLoaded = false;
      this.audio.src = 'data:audio/wave;base64,UklGRjIAAABXQVZFZm10IBIAAAABAAEAQB8AAEAfAAABAAgAAABmYWN0BAAAAAAAAABkYXRhAAAAAA==';
      this.audio.load();
      this.audio = undefined;
    }
  }

  pause() {
    this.audio?.pause();
    this.isPlaying = false;
  }

  reloadAudio() {
    this.ngOnDestroy();
    this.ngOnChanges();
    this.playPause();
  }

  onDelete() {
    this.delete.emit({
      recId: this.model.recId,
      callRecId: this.model.callRecId
    });
  }

  ngOnChanges(changes?: SimpleChanges): void {

    if (this.type === 'recording') {

      const time = moment(this.model.time).format('YYYY-MM-DD_h:mm:ss_a');
      const fileName = `recording_${this.model.extension}_${time}.wav`;

      this.src = `/api/recordings/stream-recording/${this.model.domain}/${this.model.recId}/${this.model.callRecId}`;
      this.downloadSrc = `/api/recordings/download-recording/${this.model.domain}/${this.model.recId}/${this.model.callRecId}?fileName=${fileName}`;
    }

    this.audio = new Audio();
    this.audio.addEventListener('ended', this.onAudioEnded.bind(this));
  }

  ngOnInit() {
    this.audio = new Audio();
    this.ngOnChanges();
  }

  ngOnDestroy() {
    this.stop();
  }

  onAudioEnded() {
    this.isPlaying = false;
    console.log('Play ended');
  }
}
